// @core/stores/fiscalization/FiscalizationReportStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { fiscalizationApi } from '@core/api';
import type {
  GetFiscalSummaryResponse,
} from '@core/types/fiscalization';

class FiscalizationReportStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get fiscal summary report
   */
  async GetFiscalSummary(params?: { }): Promise<GetFiscalSummaryResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await fiscalizationApi.GetFiscalSummary(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const fiscalizationReportStore = new FiscalizationReportStore();
